import { render, staticRenderFns } from "./FileDisplayer.vue?vue&type=template&id=254f3fb8&"
import script from "./FileDisplayer.vue?vue&type=script&lang=js&"
export * from "./FileDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports